import dom from './dom'
import theme from './theme'
import organization from './organization'
import cinema from './cinema'
import product from './product'

export default {
  dom,
  theme,
  organization,
  cinema,
  product
}
